

export const defaultConfig = {
  // 梳理可能出现的类型
  model: {
    id: '',
    url: 'https://mapapi.qq.com/web/dataLayerTest/model/obj/male02.obj',
    mtlUrl: '',
    position: [0.01, 0.01, 0.01], // Tmodel
    scale: [1, 1, 1],
    rotation: [0.01, 0.01, 0.01],
  },
  flowLight: {
    useFlowLight: false,
    materialMixUrl: '',
    targetUrl: '',
    duration: 4000,
    color: '#E7C474',
    range: [{ x: 0.84623, y: 0.3322 }, { x: 0.5193, y: 0.6989 }],
  },
  camera: {
    position: [0.0, 0.0, 100],
    target: [0.01, 0.01, 0.01],
    minDistance: 0,
    maxDistance: 1000,
  },
  light: [{
    type: 'AmbientLight',
    color: '#ffffff',
    intensity: 1,
    direction: [0.01, 0.01, 0.01],
    position: [0.01, 0.01, 0.01],
  },
  {
    type: 'DirectionalLight',
    color: '#ffffff',
    intensity: 1,
    direction: [0.01, 0.01, 0.01],
    position: [0.01, 0.01, 0.01],
  },
  {
    type: 'PointLight',
    color: '#ffffff',
    intensity: 1,
    direction: [0.01, 0.01, 0.01],
    position: [0.01, 0.01, 0.01],
  }],
  background: '',
  autoRotate: false, // 自动旋转
  enableEnv: true,
  polarAngle: 1,
  animation: {
    target: '',
    dest: [0.01, 0.01, 0.01],
    rotation: [0.01, 0.01, 0.01],
    easeType: 'Quadratic.In',
    duration: 1000,
  },
  circle: [{
    innerRadius: 0,
    outerRadius: 10,
    color: '#ffffff',
    radius: 50,
    position: [0, 100, 0],
    rotation: [0, 0.01, 0],
  }],
  ring: [{
    color: '#ffffff',
    type: 'half',
    radius: 50,
    position: [100, 100, 0],
    rotation: [0, 0.01, 0],
    gapsize: 5,
  }],
  line: [{
    color: '#ffffff',
    type: 'basic',
    start: [0, 0, 1],
    end: [0, 1, 0],
    gapsize: 5,
  }],
  text: [{
    content: 'test',
    position: [1, 1, 1],
    rotation: [0.01, 0.01, 0.01],
    font: 'https://mapapi.qq.com/web/dataLayerTest/fontJson/helvetiker_regular.typeface.json',
    fontSize: 3,
    height: 0.1,
    color: '#ffffff',
  }],
};


// TODO
// 1.getModelById
// 2.line dot
// 3.autoRotation

